// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import ClassStep from "./class-step.js"
import HighscoreClassStep from "./highscore-class-step.js"
import HighscoreCommune from "./highscore-commune.js"
import HighscoreCompetition from "./highscore-competition.js"
import HighscoreGeneration from "./highscore-generation.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "include_individuals": {
      "column": {
        "default": true,
        "name": "include_individuals",
        "null": false,
        "type": "boolean"
      },
      "name": "include_individuals",
      "selected_by_default": null,
      "translated": null
    },
    "include_teams": {
      "column": {
        "default": true,
        "name": "include_teams",
        "null": false,
        "type": "boolean"
      },
      "name": "include_teams",
      "selected_by_default": null,
      "translated": null
    },
    "max_instances_per_highscore": {
      "column": {
        "default": null,
        "name": "max_instances_per_highscore",
        "null": true,
        "type": "integer"
      },
      "name": "max_instances_per_highscore",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "number_of_winners": {
      "column": {
        "default": null,
        "name": "number_of_winners",
        "null": false,
        "type": "integer"
      },
      "name": "number_of_winners",
      "selected_by_default": null,
      "translated": null
    },
    "require_class_steps": {
      "column": {
        "default": false,
        "name": "require_class_steps",
        "null": false,
        "type": "boolean"
      },
      "name": "require_class_steps",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "activated",
        "name": "state",
        "null": true,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "Highscore",
  "collectionKey": "highscores",
  "collectionName": "highscores",
  "i18nKey": "highscore",
  "camelizedLower": "highscore",
  "name": "Highscore",
  "nameDasherized": "highscore",
  "pluralName": "highscores",
  "ransackable_associations": [
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_steps",
      "macro": "has_many",
      "resource_name": "ClassStep",
      "through": "highscore_class_steps"
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "commune_id",
      "name": "communes",
      "macro": "has_many",
      "resource_name": "Organization",
      "through": "highscore_communes"
    },
    {
      "className": "Competition",
      "collectionName": "competitions",
      "foreignKey": "competition_id",
      "name": "competitions",
      "macro": "has_many",
      "resource_name": "Competition",
      "through": "highscore_competitions"
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "excluded_user_id",
      "name": "excluded_users",
      "macro": "has_many",
      "resource_name": "User",
      "through": "highscore_excluded_users"
    },
    {
      "className": "HighscoreClassStep",
      "collectionName": "highscore_class_steps",
      "foreignKey": "highscore_id",
      "name": "highscore_class_steps",
      "macro": "has_many",
      "resource_name": "HighscoreClassStep",
      "through": null
    },
    {
      "className": "HighscoreCommune",
      "collectionName": "highscore_communes",
      "foreignKey": "highscore_id",
      "name": "highscore_communes",
      "macro": "has_many",
      "resource_name": "HighscoreCommune",
      "through": null
    },
    {
      "className": "HighscoreCompetition",
      "collectionName": "highscore_competitions",
      "foreignKey": "highscore_id",
      "name": "highscore_competitions",
      "macro": "has_many",
      "resource_name": "HighscoreCompetition",
      "through": null
    },
    {
      "className": "HighscoreExcludedUser",
      "collectionName": "highscore_excluded_users",
      "foreignKey": "highscore_id",
      "name": "highscore_excluded_users",
      "macro": "has_many",
      "resource_name": "HighscoreExcludedUser",
      "through": null
    },
    {
      "className": "HighscoreGeneration",
      "collectionName": "highscore_generations",
      "foreignKey": "highscore_id",
      "name": "highscore_generations",
      "macro": "has_many",
      "resource_name": "HighscoreGeneration",
      "through": null
    },
    {
      "className": "HighscoreOrganization",
      "collectionName": "highscore_organizations",
      "foreignKey": "highscore_id",
      "name": "highscore_organizations",
      "macro": "has_many",
      "resource_name": "HighscoreOrganization",
      "through": null
    },
    {
      "className": "HighscoreRegion",
      "collectionName": "highscore_regions",
      "foreignKey": "highscore_id",
      "name": "highscore_regions",
      "macro": "has_many",
      "resource_name": "HighscoreRegion",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "organization_id",
      "name": "organizations",
      "macro": "has_many",
      "resource_name": "Organization",
      "through": "highscore_organizations"
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "region_id",
      "name": "regions",
      "macro": "has_many",
      "resource_name": "Organization",
      "through": "highscore_regions"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "include_individuals",
      "column": {
        "default": true,
        "name": "include_individuals",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "include_teams",
      "column": {
        "default": true,
        "name": "include_teams",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "max_instances_per_highscore",
      "column": {
        "default": null,
        "name": "max_instances_per_highscore",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "number_of_winners",
      "column": {
        "default": null,
        "name": "number_of_winners",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "require_class_steps",
      "column": {
        "default": false,
        "name": "require_class_steps",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "activated",
        "name": "state",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_steps",
      "macro": "has_many",
      "resource_name": "ClassStep",
      "through": "highscore_class_steps"
    },
    {
      "className": "HighscoreClassStep",
      "collectionName": "highscore_class_steps",
      "foreignKey": "highscore_id",
      "name": "highscore_class_steps",
      "macro": "has_many",
      "resource_name": "HighscoreClassStep",
      "through": null
    },
    {
      "className": "HighscoreCommune",
      "collectionName": "highscore_communes",
      "foreignKey": "highscore_id",
      "name": "highscore_communes",
      "macro": "has_many",
      "resource_name": "HighscoreCommune",
      "through": null
    },
    {
      "className": "HighscoreCompetition",
      "collectionName": "highscore_competitions",
      "foreignKey": "highscore_id",
      "name": "highscore_competitions",
      "macro": "has_many",
      "resource_name": "HighscoreCompetition",
      "through": null
    },
    {
      "className": "HighscoreGeneration",
      "collectionName": "highscore_generations",
      "foreignKey": "highscore_id",
      "name": "highscore_generations",
      "macro": "has_many",
      "resource_name": "HighscoreGeneration",
      "through": null
    }
  ],
  "paramKey": "highscore",
  "primaryKey": "id"
}

/** Frontend model for Highscore. */
export default class Highscore extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  includeIndividuals() {
    return this.readAttributeUnderscore("include_individuals")
  }

  /** @returns {boolean} */
  hasIncludeIndividuals() {
    const value = this.includeIndividuals()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  includeTeams() {
    return this.readAttributeUnderscore("include_teams")
  }

  /** @returns {boolean} */
  hasIncludeTeams() {
    const value = this.includeTeams()

    return this._isPresent(value)
  }

  /** @returns {number | null} */
  maxInstancesPerHighscore() {
    return this.readAttributeUnderscore("max_instances_per_highscore")
  }

  /** @returns {boolean} */
  hasMaxInstancesPerHighscore() {
    const value = this.maxInstancesPerHighscore()

    return this._isPresent(value)
  }

  /** @returns {string} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {number} */
  numberOfWinners() {
    return this.readAttributeUnderscore("number_of_winners")
  }

  /** @returns {boolean} */
  hasNumberOfWinners() {
    const value = this.numberOfWinners()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  requireClassSteps() {
    return this.readAttributeUnderscore("require_class_steps")
  }

  /** @returns {boolean} */
  hasRequireClassSteps() {
    const value = this.requireClassSteps()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  generate(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "generate",
        primaryKey: this.primaryKey(),
        collectionName: "highscores",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./class-step.js").default>} */
  classSteps() {
    return new Collection(
      {
        reflectionName: "class_steps",
        model: this,
        modelClass: ClassStep
      },
      {
        params: {
          through: {
            model: "Highscore",
            id: this.primaryKey(),
            reflection: "class_steps"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./class-step.js").default>>} */
  loadClassSteps() {
    return this._loadHasManyReflection(
      {
        reflectionName: "class_steps",
        model: this,
        modelClass: ClassStep
      },
      {
        params: {
          through: {
            model: "Highscore",
            id: this.primaryKey(),
            reflection: "class_steps"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./class-step.js").default>>} */
  ensureClassStepsLoaded() {
    return this.ensureAssociationLoaded("class_steps")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./highscore-class-step.js").default>} */
  highscoreClassSteps() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["highscore_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "highscore_class_steps",
        model: this,
        modelClass: HighscoreClassStep
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./highscore-class-step.js").default>>} */
  loadHighscoreClassSteps() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["highscore_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "highscore_class_steps",
        model: this,
        modelClass: HighscoreClassStep
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./highscore-class-step.js").default>>} */
  ensureHighscoreClassStepsLoaded() {
    return this.ensureAssociationLoaded("highscore_class_steps")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./highscore-commune.js").default>} */
  highscoreCommunes() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["highscore_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "highscore_communes",
        model: this,
        modelClass: HighscoreCommune
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./highscore-commune.js").default>>} */
  loadHighscoreCommunes() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["highscore_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "highscore_communes",
        model: this,
        modelClass: HighscoreCommune
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./highscore-commune.js").default>>} */
  ensureHighscoreCommunesLoaded() {
    return this.ensureAssociationLoaded("highscore_communes")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./highscore-competition.js").default>} */
  highscoreCompetitions() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["highscore_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "highscore_competitions",
        model: this,
        modelClass: HighscoreCompetition
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./highscore-competition.js").default>>} */
  loadHighscoreCompetitions() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["highscore_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "highscore_competitions",
        model: this,
        modelClass: HighscoreCompetition
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./highscore-competition.js").default>>} */
  ensureHighscoreCompetitionsLoaded() {
    return this.ensureAssociationLoaded("highscore_competitions")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./highscore-generation.js").default>} */
  highscoreGenerations() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["highscore_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "highscore_generations",
        model: this,
        modelClass: HighscoreGeneration
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./highscore-generation.js").default>>} */
  loadHighscoreGenerations() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["highscore_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "highscore_generations",
        model: this,
        modelClass: HighscoreGeneration
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./highscore-generation.js").default>>} */
  ensureHighscoreGenerationsLoaded() {
    return this.ensureAssociationLoaded("highscore_generations")
  }
}
